import React from 'react';
import { BtnLoader } from "src/Loader";
import { PromoCodeSectionProps } from "../../../../interfaces/order-management-props.interface";

const PromoCodeSection = ({
  showPromoField,
  promoCode,
  promoloading,
  promoMessage,
  promoError,
  onShowPromoField,
  onHidePromoField,
  onPromoCodeChange,
  onApplyPromo,
}: PromoCodeSectionProps) => {
  if (!showPromoField) {
    return (
      <button
        className="bg-[#F5F5F6] px-4 py-2 text-sm text-black rounded-lg mt-2"
        onClick={onShowPromoField}
      >
        Have a promotion code?
      </button>
    );
  }

  return (
    <div>
      <div className="!text-black !font-semibold mt-2">
        Promo code / coupon
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2 justify-between">
        <input
          className="h-[40px] text-xs border rounded-lg border-[#F1F1F2] mt-1 px-2 w-full"
          placeholder=" Enter your promo code / coupon"
          type="text"
          onChange={(e) => onPromoCodeChange(e.target.value)}
          value={promoCode}
        />
        <div className="w-full sm:w-auto">
          {promoloading ? (
            <BtnLoader />
          ) : (
            <button
              onClick={onApplyPromo}
              className="bg-[#FD7657] px-2 py-2 text-sm text-white rounded-lg w-full sm:w-[100px]"
            >
              Apply now
            </button>
          )}
        </div>
      </div>
      {promoMessage ? (
        <p
          className={`mt-2 text-xs ${
            promoError ? "text-[#B91C1C]" : "text-[#047857]"
          }`}
        >
          {promoMessage}
        </p>
      ) : null}
      <button
        className="bg-[#F5F5F6] px-4 py-2 text-sm text-black rounded-lg mt-2"
        onClick={onHidePromoField}
      >
        Hide
      </button>
    </div>
  );
};

export default PromoCodeSection;

